export const SET_COMMON_CONFIG = "SET_COMMON_CONFIG"
export const SET_CURRENT_STEP = "SET_CURRENT_STEP"
export const SET_CLICK_STEP = "SET_CLICK_STEP"
export const SET_IS_SETTING_COACH_MARK = "SET_IS_SETTING_COACH_MARK"
export const SET_IS_BANNER_AVAILABLE = "SET_IS_BANNER_AVAILABLE";
